import ICategory from 'app/interfaces/addons/ICategory';

const getConcreteCategories = (categories: ICategory[]): ICategory[] =>
  categories.filter((cat) => cat.id !== 'all');

export default getConcreteCategories;
